import React, { useState, useRef, useCallback } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Tooltip from '@mui/material/Tooltip';
import { Document, Page, Text, StyleSheet, View, Image, PDFDownloadLink, PDFViewer, Font, Svg } from '@react-pdf/renderer';
import DialogTitle from '@mui/material/DialogTitle';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import { DataGrid } from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import chFont from '../../../css/font/TaipeiSansTCBeta-Bold.ttf';
import chLight from '../../../css/font/TaipeiSansTCBeta-Light.ttf';
import apiClient from '../ApiClient/ApiClient';
import Bill from '../bill/Bill';
import { prepareImportReview, getImportExceptions, getImportSummary, buildImportCommit, downloadImportExceptions } from './shipmentImportReview';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const columns = [
    
    {
        field: 'toShipDate',
        headerName: '出貨日期',
        width: 150,
        editable: false,
    },
    {
        field: 'toShipNum',
        headerName: '出貨單號',
        width: 150,
        editable: false,
    },
    {
        field: 'orderNum',
        headerName: '訂單號碼',
        width: 150,
        editable: false,
    },
    {
        field: 'serialNum',
        headerName: '流水號',
        width: 70,
        editable: false,
    },
    {
        field: 'mechaine',
        headerName: '機種',
        width: 50,
        editable: false,
    },
    {
        field: 'drawNum',
        headerName: '圖號',
        width: 110,
        editable: false,
    },
    {
        field: 'itemNum',
        headerName: '項次',
        width: 60,
        editable: false,
    },
    {
        field: 'itemName',
        headerName: '物品名',
        width: 200,
        editable: true,
    },
    {
        field: 'unit',
        headerName: '單位',
        width: 50,
        editable: false,
    },
    {
        field: 'realGive',
        headerName: '實交貨數',
        width: 100,
        type:'number',
        editable: false,
    },
    {
        field: 'orderPrice',
        headerName: '訂購單價',
        type:'number',
        width: 150,
        editable: true,
    },
    {
        field: 'amountReceivable',
        headerName: '應收金額',
        type:'number',
        width: 150,
        editable: false,
    },
    {
        field: 'company',
        headerName: '承製公司',
        width: 150,
        editable: false,
    },
    {
        field: 'client',
        headerName: '客戶',
        width: 150,
        editable: false,
    },
    { field: 'id', headerName: 'ID', width: 90 },
];

const columnsShip= [
    
    {
        field: '出貨日期',
        headerName: '出貨日期',
        width: 120,
        editable: false,
    },
    {
        field: '出貨單號',
        headerName: '出貨單號',
        width: 120,
        editable: false,
    },
    {
        field: '訂單號碼',
        headerName: '訂單號碼',
        width: 110,
        editable: false,
    },
    {
        field: '流水號',
        headerName: '流水號',
        width: 80,
        editable: false,
    },
    {
        field: '圖號',
        headerName: '圖號',
        width: 110,
        editable: false,
    },
    {
        field: '項次',
        headerName: '項次',
        width: 60,
        editable: false,
    },
    {
        field: '物品名',
        headerName: '物品名',
        width: 110,
        editable: false,
    },
    {
        field: '單位',
        headerName: '單位',
        width: 60,
        editable: false,
    },
    {
        field: '實交貨數',
        headerName: '實交貨數',
        width: 110,
        editable: false,
    },
    {
        field: '訂購單價',
        headerName: '訂購單價',
        width: 110,
        editable: true,
    },
    {
        field: '應收金額',
        headerName: '應收金額',
        width: 110,
        editable: false,
        valueFormatter: (params) => {
            return Number(params.value).toLocaleString('zh-TW', { maximumFractionDigits: 0 });
        },
    },
    {
        field: '機種',
        headerName: '機種',
        width: 60,
        editable: false,
    },  
    {
        field: '承製公司',
        headerName: '承製公司',
        width: 110,
        editable: false,
    },
    {
        field: '客戶',
        headerName: '客戶',
        width: 110,
        editable: false,
    },
    { field: 'id', headerName: 'ID', width: 90 },
];

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getMonth() 返回的是 0-11，代表月份
    const day = date.getDate();

    // 使用模板字符串，并确保月份和日期为两位数
    return `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;
};

export default function ReceivableAccount() {
    const [rows, setRows] = React.useState([]);
    const [rows2, setRows2] = React.useState([]);
    const [makeCom, setMakeCom] = React.useState('34005573');
    const [client, setClient] = React.useState('台日');
    const [orderNum, setOrderNum] = React.useState('');
    const [drawNum, setDrawNum] = React.useState('');
    const [toshipNum, setToshipNum] = React.useState('');
    const [shipNum, setshipNum] = React.useState('');
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = useState(false); // 加入 loading 狀態
    const [selectedOption, setSelectedOption] = React.useState({
        id: 753,
        label: null,
        manufacturer_Seq: "4500001",
        manufacturer_AbbreviationName: "台日",
        manufacturer_FullName: "台灣日立江森自控股份有限公司",
        manufacturer_UniformNum: "11915305",
        manufacturer_CityCode: "33810",
        manufacturer_FaxNum: "03-3245321",
        manufacturer_BossName: null,
        manufacturer_ContactName: null,
        manufacturer_CompanyAddress: "台北市南京東路三段63號",
        manufacturer_CompanyPhone: "03-3244711",
        manufacturer_CompanyFax: "03-3245321",
        manufacturer_ShipAddress: "桃園縣蘆竹鄉內厝村內溪路２９號",
        manufacturer_ShipAddress2: null,
        manufacturer_ShipAddress3: null,
        manufacturer_FactoryNum: null,
        manufacturer_FactoryFax: null,
        manufacturer_AccCode: "6116",
        manufacturer_PayMent: null
    });
    const [billNum, setBillNum] = React.useState('');
    const [billDate, setBillDate] = React.useState(formatDate(new Date()));
    const [orderWay, setOrderWay] = React.useState('num');

    const [billData, setBillData] = React.useState(null);
    const [print, setPrint] = React.useState(false);
    const [taxway, setTaxWay] = React.useState(3);
    const [tax, setTax] = React.useState(5);
    const isClosed = billData?.lock === 1;

    const getErrorMessage = (error, fallback) =>
        error?.response?.data?.message || error?.response?.data || error?.message || fallback;

    // 新增的狀態變量
    const [adjustDialogOpen, setAdjustDialogOpen] = useState(false); // 控制合計金額微調對話框
    const [newTotalAmount, setNewTotalAmount] = useState(''); // 用戶輸入的新合計金額
    const [importPreview, setImportPreview] = useState(null);
    const [importPreviewOpen, setImportPreviewOpen] = useState(false);
    const [importPage, setImportPage] = useState(1);
    const [confirmImportSkipped, setConfirmImportSkipped] = useState(false);
    const [manualImport, setManualImport] = useState(null);
    const importRows = importPreview?.rows || [];
    const importExceptions = getImportExceptions(importRows);
    const importSummary = getImportSummary(importRows);

    const fileInputRef = useRef(null);
    const fileInputRef2 = useRef(null);

    const handleLockChange = async (event) => {
        if (!billNum) {
            alert('請先輸入並查詢發票號碼');
            return;
        }

        const actionText = isClosed ? '解除結案' : '結案';
        if (!window.confirm(`確定要${actionText}發票「${billNum}」嗎？`)) return;

        setLoading(true);
        try {
            const endpoint = isClosed ? '/ReceviableAccount/UnlockBill' : '/ReceviableAccount/CloseBill';
            const response = await apiClient.post(endpoint, { billNo: billNum });
            if (response.status === 200) {
                setBillData(response.data);
                alert(`${actionText}完成`);
            } else {
                alert(`${actionText}失敗`);
            }
        } catch (error) {
            console.error(`${actionText}失敗:`, error);
            alert(getErrorMessage(error, `${actionText}失敗`));
        }finally{
            setLoading(false);
        }

    };

    const handleButtonClick = async () => {
        if(!billNum || !billDate){
            alert("請輸入發票號碼與發票日期")
        }else{
        try {
           
                fileInputRef.current.click();       
            
        } catch (error) {
            console.error('Error checking bill existence:', error);
            alert('查無該發票資訊');
        }
    }
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        uploadShipExcel(file); // 假設這是上傳檔案的函數
        event.target.value = ''; // 清空上傳的檔案
    };

    const handleButtonClick2 = () => {
        fileInputRef2.current.click();
    };

    const fetchOptions = async () => {
        setLoading(true);
        try {    
            const response = await apiClient.get(`/Manufacturer/list`);
            if (response.status === 200) {
                setOptions(response.data.manufacturers);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };

    const handleFileChange2 = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        await checkUploadShipExcel(file); // 使用新的函數
        event.target.value = ''; // 清空上傳的文件
    };

    const checkUploadShipExcel = async (file) => {
        setLoading(true);
        try {
            // 創建一個 FormData 對象來存儲文件數據
            const formData = new FormData();
            formData.append("excel", file);
        
            // 發送 POST 請求到後端
            const response = await apiClient.post(`/ReceviableAccount/CheckShipExcel?no=${billNum}`, formData, {
                responseType: 'blob', // 重要：為了正確接收文件
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        
            // 檢查響應狀態並處理返回的文件
            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', '異常發票比對明細.xlsx'); // 設置下載的文件名
                document.body.appendChild(link);
                link.click();
            } else {
                alert('文件處理失敗');
            }
        } catch (error) {
            console.error('Failed to process file:', error);
            alert('文件處理失敗');
        }finally{
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`/ReceviableAccount/GetMainsByFilter`, {
                params: {
                    makeCom,
                    client,
                    orderNum,
                    drawNum,
                    toshipNum
                }
            });
        
            if (response.data.statusCode === 200) {
                setRows(response.data.receviableAccounts);           
            } else {
                alert('查詢失敗');
            }
        } catch (error) {
            console.error('Failed to add data:', error);
            alert('查詢失敗');
        }finally{
            setLoading(false);
        }
    };

    const handleSearchBelow = async (toshipNo) => {
        setLoading(true);
        setshipNum(toshipNo);
        try {
            const url = `/ReceviableAccount/GetShipData`;
            const response = await apiClient.get(url, {
                params: {
                    billNum: billNum || '',
                    date: billDate || '',
                    way: orderWay || '',
                    toshipNo: toshipNo || ''
                }
            });
            if (response.status === 200) {
                setRows2(response.data);
                handleSearchBillData();
            } else {
                alert('查詢失敗');
            }
        } catch (error) {
            console.error('Failed to add data:', error);
            alert('查詢失敗');
        }finally{
            setLoading(false);
        }
    };

    const SaveShipData = async () => {

        if (isClosed) {
            alert('此應收對帳單已結案，不能修改');
            return;
        }

        setLoading(true);
        try {
            const additionalData = rows2.map(row => ({
                Id: row.id,
                realGive: parseFloat(row.實交貨數) || 0, // 確保值為數字
                orderPrice: parseFloat(row.訂購單價) || 0, // 確保值為數字
                amountReceivable: parseFloat(row.應收金額) || 0, // 確保值為數字
            }));
            console.log(additionalData);
            const response = await apiClient.post(`/ReceviableAccount/SaveShipData`, additionalData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (response.status === 200) {
                setRows2(response.data); // 將後端返回的資料寫入 rows2
                alert('儲存成功');
            } else {
                alert('儲存失敗');
            }
        } catch (error) {
            console.error('Failed to save data:', error);
            alert(error.response?.data?.message || '儲存失敗');
        }finally{
            setLoading(false);
        }
    };
    

    const UpdateBelow = async () => {
        try {
            const response = await apiClient.get(`/ReceviableAccount/UpdateShipData`, {
                params: { billNum }
            });
        
            if (response.status === 200) {
                await handleSearchBelow(null);
                alert('刪除成功');
            } else {
                alert('刪除失敗');
            }
        } catch (error) {
            console.error('Failed to add data:', error);
            alert(error.response?.data?.message || '刪除失敗');
        }
    };

    const handleSearchBillData = async () => {
        try {
            const response = await apiClient.get(`/ReceviableAccount/GetBillData`, {
                params: { billNum }
            });
            if (response.status === 200 || response.status === 204) {
                setBillData(response.data);
            } else {
                alert('查詢失敗');
            }
        } catch (error) {
            console.error('Failed to add data:', error);
            alert('查詢失敗');
        }
    };

    const handleClickOpenList = async () => {
        try {
            const response = await apiClient.get(`/ReceviableAccount/GetBillDataList`, {
                params: {
                    billNum: billNum || '',
                    date: billDate || '',
                    way: orderWay || '',
                },
                responseType: 'blob' // 設置 responseType 為 blob
            });
        
            if (response.status === 200 || response.status === 204) {
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                const pdfUrl = URL.createObjectURL(pdfBlob);
                window.open(pdfUrl);
            } else {
                alert('查詢失敗');
            }
        } catch (error) {
            console.error('Failed to fetch PDF:', error);
            alert('查詢失敗');
        }
    };

    const handleRecaculateBillData = async () => {
        if (isClosed) {
            alert('此應收對帳單已結案，不能重新計算');
            return;
        }
        setLoading(true);
        try {
            const dataToSend = {
                data: rows2, 
                way: taxway,
                num: tax,
                billNum,
                date: billDate
            };
        
            // 發起 POST 請求
            const response = await apiClient.post(`/ReceviableAccount/NewRecaculate`, dataToSend);
        
            if (response.status === 200) {
                setBillData(response.data);
            } else {
                alert('重新計算失敗');
            }
        } catch (error) {
            console.error('Failed to recalculate bill data:', error);
            alert(error.response?.data?.message || '重新計算失敗');
        }finally{
            setLoading(false);
        }

    };

    const uploadShipExcel = async (file) => {
        try {
            const formData = new FormData();
            formData.append("excel", file);
            setLoading(true);
            const response = await apiClient.post(`/ReceviableAccount/ShipExcel/Preview`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.status === 200) {
                setImportPreview(prepareImportReview(response.data.data));
                setImportPage(1);
                setConfirmImportSkipped(false);
                setImportPreviewOpen(true);
            }
        } catch (error) {
            console.error('Failed to preview file:', error);
            alert(getErrorMessage(error, 'Excel 預覽失敗'));
        } finally{
            setLoading(false);
        }
    };

    const selectImportCandidate = (rowNumber, candidate) => {
        const candidateIds = candidate.lines.map(line => line.id);
        const alreadyUsed = (importPreview?.rows || []).some(row => !row.skip && row.rowNumber !== rowNumber &&
            row.selectedShipmentIds?.some(id => candidateIds.includes(id)));
        if (alreadyUsed) { alert('這組候選明細已被其他 Excel 列選取，請改選另一組。'); return false; }
        const target = importRows.find(row => row.rowNumber === rowNumber);
        const total = candidate.lines.reduce((sum, line) => sum + Number(line.quantity), 0);
        if (!target?.billNum || !target?.orderNum || !target?.serialNum || target.quantity <= 0 || Math.abs(total - target.quantity) > 0.000001) {
            alert('必要欄位或數量不符，請修正 Excel 後重新預覽，或確認略過。'); return false;
        }
        setConfirmImportSkipped(false);
        setImportPreview(previous => ({
            ...previous,
            rows: previous.rows.map(row => row.rowNumber === rowNumber ? {
                ...row,
                selectedShipmentIds: candidateIds,
                selectedLines: candidate.lines,
                skip: false,
                status: 'Success',
                message: '已由使用者選擇配對。'
            } : row)
        }));
        return true;
    };

    const skipImportRows = (rowNumber, skip) => {
        setConfirmImportSkipped(false);
        setImportPreview(previous => ({ ...previous, rows: previous.rows.map(row =>
            row.rowNumber === rowNumber ? { ...row, skip } : row) }));
    };

    const skipPendingImportRows = () => {
        if (!window.confirm(`將尚未處理的 ${importSummary.pending} 筆異常標記為略過？這些資料不會寫入。`)) return;
        setConfirmImportSkipped(false);
        setImportPreview(previous => ({ ...previous, rows: previous.rows.map(row =>
            row.isException && row.status !== 'Success' ? { ...row, skip: true } : row) }));
    };

    const loadManualImportPage = async (row, page = 1, selected = []) => {
        setLoading(true);
        try {
            const response = await apiClient.get('/ReceviableAccount/ShipExcel/Candidates', {
                params: { orderNum: row.orderNum, serialNum: row.serialNum, page }
            });
            setManualImport({ row, page, selected, ...response.data.data });
        } catch (error) { alert(getErrorMessage(error, '候選明細查詢失敗')); }
        finally { setLoading(false); }
    };

    const commitShipmentImport = async () => {
        let request;
        try { request = buildImportCommit(importRows, billDate, confirmImportSkipped); }
        catch (error) { alert(error.message); return; }
        if (!window.confirm(`確認寫入 ${importSummary.write} 列，略過 ${importSummary.skipped} 列？略過資料不會寫入；其餘資料若驗證失敗，這次提交全部不寫入。`)) return;
        setLoading(true);
        try {
            const response = await apiClient.post('/ReceviableAccount/ShipExcel/Commit', request);
            alert(response.data.message || '整批匯入完成');
            setImportPreviewOpen(false);
            setImportPreview(null);
            handleSearchBelow(null);
        } catch (error) {
            alert(getErrorMessage(error, '整批匯入失敗，所有資料均未寫入。'));
        } finally { setLoading(false); }
    };

    const handleClickOpen = async () => {
        await handleSearchBelow(); // 等待 handleSearchBelow 完成
        setPrint(true);
    };

    const handleChange = (event, newValue) => {
        setSelectedOption(newValue);
        if(newValue === null || newValue === undefined) return;
        setClient(newValue.manufacturer_AbbreviationName); 
    };

    const handleRowDoubleClick = async (params) => {
        if (isClosed) {
            alert('已上鎖 不得修改');
            return;
        }
        if (billNum === null || billNum === undefined || billNum === "") {
            alert('發票號碼未輸入！');
            return;
        }
        
        setLoading(true);
        try {
            const response = await apiClient.post(`/ReceviableAccount/DoubleClickBill`, {
                Id: params.row.id,
                Date: billDate,
                BillNo: billNum
            });
            if(response.status === 200 || response.status === 204) {
                await handleSearch();
                await handleSearchBelow(params.row.toShipNum);
            }
        } catch (error) {
            console.error('請求錯誤', error);
            alert(error.response?.data?.message || '開立或移除發票失敗');
        }finally{
            setLoading(false);
        }
    };

    const handleClose = () => {
        setPrint(false);
    };

    React.useEffect(() => {
        fetchOptions();
    }, []); 

    React.useEffect(() => {
        if (billData && billData.date) {
            setBillDate(billData.date);
        }
    }, [billData]); 

    React.useEffect(() => {
        if (rows2.length === 0 ) {
            setBillData(billData => ({
                ...billData,
                稅額: "",
                金額: "",
                總計: ""  // 修改屬性為新值
            }));
        }
    }, [rows2]);

    const handleAdjustAmount = () => {
        if (isClosed) {
            alert('此應收對帳單已結案，不能微調金額');
            return;
        }
        setAdjustDialogOpen(true); // 打開對話框
        setNewTotalAmount('0'); // 初始化輸入框的值為當前合計金額
    };

    const handleExportExcel = async () => {
      setLoading(true);
        try 
      {
        
        const response = await apiClient.post(
            `/ReceviableAccount/BillExcel?billNo=${billNum}`,
            null, // 如果需要傳送資料，請在這裡傳遞
            {
                responseType: 'blob', // 設置回應類型為 blob
            }
        );
        if (response.status === 200 && response.data) {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'BillData.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            alert('Excel 文件已成功下載。');
        } else {
            alert('生成 Excel 文件失敗。');
        }
    } catch (error) {
        console.error('生成 Excel 文件失敗:', error);
        alert('生成 Excel 文件時發生錯誤。');
    }finally{
        setLoading(false);
    }
    };

    const processRowUpdate = useCallback((newRow, oldRow) => {
        // 根據訂購單價和實交貨數計算應收金額
        const updatedRow = { 
            ...oldRow, 
            ...newRow, 
            應收金額: !Number.isNaN(newRow['訂購單價']) && !Number.isNaN(newRow['實交貨數'])
                ? newRow['訂購單價'] * newRow['實交貨數']
                : oldRow['應收金額'],
        };
    
        // 更新 rows2 中的對應數據
        setRows2((prevRows) =>
            prevRows.map((row) => (row.id === newRow.id ? updatedRow : row))
        );
    
        // 返回更新後的行
        return updatedRow;
    }, []);
    
    const handleSubmitAdjustAmount = async () => {
        if (isClosed) {
            alert('此應收對帳單已結案，不能微調金額');
            setAdjustDialogOpen(false);
            return;
        }
        if (!newTotalAmount || Number.isNaN(newTotalAmount)) {
            alert('請輸入有效的金額');
            return;
        }

        setLoading(true);
        try {
            // 假設您需要將新的合計金額發送到後端進行更新
            const response = await apiClient.post(`/ReceviableAccount/UpdateTotalAmount`, {
              billNum,
              newTotalAmount: Number(newTotalAmount),
              tax,
              way:taxway,
            });
              if (response.status === 200) {
                  alert('合計金額更新成功');
                  setAdjustDialogOpen(false); // 關閉對話框
                  // setRows2([]);
                  handleSearchBelow(); // 重新查詢以更新界面
              } else {
                  alert('合計金額更新失敗');
              }
          
            } catch (error) {
                console.error('更新合計金額失敗:', error);
                alert('更新合計金額失敗');
            }finally{
                setLoading(false);
            }
    };

    return (
        <>
            <Box sx={{ height: 400, width: '100%', margin: '10px' }}>
            <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
                <FormControl sx={{ margin: '10px' }}>
                    <InputLabel id="demo-simple-select-label">承製公司</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={makeCom}
                        label="承製公司"
                        onChange={(e) => setMakeCom(e.target.value)}
                    >
                        <MenuItem value={'23032911'}>23032911</MenuItem>
                        <MenuItem value={'34005573'}>34005573</MenuItem>
                        <MenuItem value={'00047613'}>00047613</MenuItem>
                        <MenuItem value={'86841262'}>86841262</MenuItem>
                    </Select>
                </FormControl>
                <FormControl sx={{ margin: '10px' }}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={options}
                        sx={{ width: '100%' }}
                        value={selectedOption}
                        onChange={handleChange}
                        getOptionLabel={(option) => option.manufacturer_AbbreviationName}
                        // 設置renderInput來渲染輸入元件
                        renderInput={(params) => <TextField {...params} label="客戶" />}
                    />
                </FormControl>
                <TextField sx={{ margin: '10px' }} id="outlined-basic" label="訂單號碼" variant="outlined" onChange={(e)=>setOrderNum(e.target.value)}/>
                <TextField sx={{ margin: '10px' }} id="outlined-basic" label="圖號" variant="outlined" onChange={(e)=>setDrawNum(e.target.value)}/>
                <TextField sx={{ margin: '10px' }} id="outlined-basic" label="出貨單號" variant="outlined" onChange={(e)=>setToshipNum(e.target.value)}/>
                <Button sx={{ margin: '10px', marginTop: '20px' }} variant="contained" endIcon={<SendIcon />} onClick={handleSearch}>
                    搜尋
                </Button>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 20,
                            },
                        },
                    }}
                    onRowDoubleClick={handleRowDoubleClick}
                    pageSizeOptions={[20,30,40]}
                    disableRowSelectionOnClick
                />
            </Box>
            <Box sx={{ height: 400, width: '90%', margin: '10px', marginTop: '10%' }}>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <TextField id="outlined-basic" label="發票號碼" variant="outlined" value={billNum} onChange={(e)=>setBillNum(e.target.value)}/>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField id="outlined-basic" label="發票日期" variant="outlined"           
                            value={billDate}
                            onChange={(e)=>setBillDate(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={orderWay}
                                onChange={(e)=>setOrderWay(e.target.value)}
                            >
                                <FormControlLabel value="num" control={<Radio />} label="按圖號+批號 排" />
                                <FormControlLabel value="date" control={<Radio />} label="按出貨日期 排" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={()=>handleSearchBelow(null)}>搜尋</Button>
                    </Grid>
                    <Grid item xs={2}>
                        <input
                            type="file"
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <Button variant="contained" onClick={handleButtonClick} disabled={isClosed}>
                            匯入發票2015
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <input
                            type="file"
                            style={{ display: 'none' }}
                            ref={fileInputRef2}
                            onChange={handleFileChange2}
                        />
                        <Button variant="contained" onClick={handleButtonClick2} disabled={isClosed}>
                            發票比對2015
                        </Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={UpdateBelow} disabled={isClosed}>刪除發票</Button>
                    </Grid>
                    <Grid item xs={2}>
                        <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">小數點</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={taxway}
                                onChange={(e)=>setTaxWay(e.target.value)}
                            >
                                <FormControlLabel value={1} control={<Radio />} label="無條件進位" />
                                <FormControlLabel value={3} control={<Radio />} label="四捨五入" />
                                <FormControlLabel value={2} control={<Radio />} label="無條件捨去" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField id="outlined-basic" label="稅率" variant="outlined" value={tax} onChange={(e)=>setTax(e.target.value)}/>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" onClick={handleRecaculateBillData} disabled={isClosed}>計算</Button>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            id="outlined-basic" 
                            label="合計" 
                            variant="outlined" 
                            value={billData ? billData.金額 : ''} 
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                        {/* 使用 Box 來佈局按鈕 */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleAdjustAmount}
                                disabled={isClosed}
                                fullWidth
                                sx={{ mr: 1 }}
                            >
                                合計金額微調
                            </Button>
                            <Button 
                                variant="contained" 
                                color="secondary" 
                                onClick={handleExportExcel}
                                fullWidth
                            >
                                匯出EXCEL
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            id="outlined-basic" 
                            label="營業稅" 
                            variant="outlined" 
                            value={billData ? billData.稅額 : ''} 
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField 
                            id="outlined-basic" 
                            label="總計" 
                            variant="outlined" 
                            value={billData ? billData.總計 : ''} 
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <FormGroup>
                            <FormControlLabel 
                                control={
                                    <Checkbox 
                                        checked={isClosed}
                                        onChange={handleLockChange}
                                    />
                                } 
                                label="已結案" 
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" onClick={handleClickOpenList}>對帳單</Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={SaveShipData} 
                            disabled={isClosed} // 根據 lock 狀態禁用按鈕
                        >
                        儲存變更
                    </Button>
                </Grid>
                </Grid>
                <DataGrid
                    rows={rows2}
                    columns={columnsShip}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 100,
                            },
                        },
                    }}
                    onRowDoubleClick={handleRowDoubleClick}
                    pageSizeOptions={[100]}
                    disableRowSelectionOnClick
                    processRowUpdate={processRowUpdate} // 使用 processRowUpdate
                    isCellEditable={(params) => !isClosed && Boolean(params.colDef.editable)}
                    experimentalFeatures={{ newEditingApi: true }} // 啟用新編輯 API
                    onProcessRowUpdateError={(error) => {
                        console.error(error);
                        alert('更新失敗，請稍後再試。');
                    }}
                />
            </Box>

            <Dialog open={importPreviewOpen} onClose={() => { if (!loading) setImportPreviewOpen(false); }} maxWidth="lg" fullWidth>
                <DialogTitle>出貨發票匯入預覽</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>
                        共 {importSummary.total} 筆；自動配對 {importSummary.normal} 筆；
                        異常已指定 {importSummary.resolved} 筆；待處理 {importSummary.pending} 筆；
                        略過 {importSummary.skipped} 筆；預計寫入 {importSummary.write} 筆
                    </Typography>
                    <Typography sx={{ mb: 1 }}>僅顯示異常資料，每頁 20 筆。正常資料將一併寫入；手動指定仍須符合原訂單、流水號與數量。</Typography>
                    <Button disabled={loading || !importExceptions.length} onClick={() => downloadImportExceptions(importRows, sessionStorage.getItem('company'))}>下載異常 Excel</Button>
                    <Button disabled={loading || !importSummary.pending} onClick={skipPendingImportRows}>將未處理異常全部略過</Button>
                    {!importExceptions.length && <Typography sx={{ my: 2 }}>所有資料均已自動配對，沒有異常。</Typography>}
                    {importExceptions.slice((importPage - 1) * 20, importPage * 20).map(row => (
                        <Box key={row.rowNumber} sx={{ border: '1px solid #ddd', borderRadius: 1, p: 1.5, mb: 1.5 }}>
                            <Typography color={row.status === 'Error' ? 'error' : row.status === 'Conflict' ? 'warning.main' : 'success.main'}>
                                Excel 第 {row.rowNumber} 列｜發票 {row.billNum}｜訂單 {row.orderNum}-{row.serialNum}｜數量 {row.quantity}｜{row.skip ? '已標記略過，不會寫入' : row.message}
                            </Typography>
                            <Typography variant="body2">原始異常：{row.originalMessage}</Typography>
                            <FormControlLabel control={<Checkbox checked={!!row.skip} disabled={loading} onChange={event => skipImportRows(row.rowNumber, event.target.checked)} />} label="確認略過本列" />
                            <Button disabled={loading || row.skip || !row.canManuallyAssign}
                                onClick={() => loadManualImportPage(row, 1, row.selectedLines || [])}>手動指定出貨明細</Button>
                            {!!row.selectedShipmentIds?.length && !row.skip && <Typography variant="body2">已指定 ID：{row.selectedShipmentIds.join('、')}</Typography>}
                            {row.candidates?.map(candidate => {
                                const ids = candidate.lines.map(line => line.id);
                                const selected = ids.length === row.selectedShipmentIds?.length && ids.every(id => row.selectedShipmentIds.includes(id));
                                return (
                                    <Box key={candidate.key} sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
                                        <Radio checked={selected && !row.skip} disabled={loading || row.skip} onChange={() => selectImportCandidate(row.rowNumber, candidate)} />
                                        <Box>
                                            <Typography>候選組合：{candidate.lines.map(line => `ID ${line.id}`).join('、')}</Typography>
                                            {candidate.lines.map(line => (
                                                <Typography variant="body2" key={line.id}>
                                                    ID {line.id}｜出貨單 {line.shipNum}｜日期 {line.shipDate}｜批號 {line.batchNum}｜圖號 {line.drawNum}｜數量 {line.quantity}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    ))}
                    {!!importExceptions.length && <Pagination page={importPage} count={Math.ceil(importExceptions.length / 20)} onChange={(_, page) => setImportPage(page)} disabled={loading} />}
                    {importSummary.skipped > 0 && <FormControlLabel control={<Checkbox checked={confirmImportSkipped} disabled={loading} onChange={event => setConfirmImportSkipped(event.target.checked)} />}
                        label={`已核對略過清單，同意 ${importSummary.skipped} 筆不寫入，其餘 ${importSummary.write} 筆匯入`} />}
                </DialogContent>
                <DialogActions>
                    <Button disabled={loading} onClick={() => setImportPreviewOpen(false)}>取消</Button>
                    <Button variant="contained" disabled={loading || !importSummary.write || importSummary.pending > 0 || (importSummary.skipped > 0 && !confirmImportSkipped)} onClick={commitShipmentImport}>確認匯入 {importSummary.write} 筆</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!manualImport} onClose={() => { if (!loading) setManualImport(null); }} maxWidth="lg" fullWidth>
                <DialogTitle>手動指定出貨明細</DialogTitle>
                <DialogContent>
                    <Typography>Excel 第 {manualImport?.row.rowNumber} 列｜訂單 {manualImport?.row.orderNum}-{manualImport?.row.serialNum}｜目標數量 {manualImport?.row.quantity}</Typography>
                    <Typography sx={{ my: 1 }}>已選數量：{manualImport?.selected.reduce((sum, line) => sum + Number(line.quantity), 0) || 0}；可跨頁選取，相加必須等於 Excel 數量。</Typography>
                    <Typography variant="body2">已選 ID：{manualImport?.selected.map(line => line.id).join('、') || '尚未選擇'}</Typography>
                    {!manualImport?.lines.length && <Typography sx={{ my: 2 }}>查無相同訂單及流水號的可用出貨明細，請返回後確認略過，或修正 Excel。</Typography>}
                    {manualImport?.lines.map(line => {
                        const used = importRows.some(row => !row.skip && row.rowNumber !== manualImport.row.rowNumber && row.selectedShipmentIds?.includes(line.id));
                        return <Box key={line.id}>
                            <FormControlLabel label={`ID ${line.id}｜出貨單 ${line.shipNum}｜日期 ${line.shipDate}｜批號 ${line.batchNum}｜圖號 ${line.drawNum}｜數量 ${line.quantity}${used ? '（其他列已選取）' : ''}`}
                                control={<Checkbox checked={manualImport.selected.some(item => item.id === line.id)} disabled={loading || used}
                                    onChange={event => { const checked = event.target.checked; setManualImport(previous => ({ ...previous,
                                        selected: checked ? [...previous.selected, line] : previous.selected.filter(item => item.id !== line.id) })); }} />} />
                        </Box>;
                    })}
                    <Button disabled={loading || !manualImport || manualImport.page === 1} onClick={() => loadManualImportPage(manualImport.row, manualImport.page - 1, manualImport.selected)}>上一頁</Button>
                    <Typography component="span">第 {manualImport?.page} 頁（每頁 50 筆）</Typography>
                    <Button disabled={loading || !manualImport?.hasMore} onClick={() => loadManualImportPage(manualImport.row, manualImport.page + 1, manualImport.selected)}>下一頁</Button>
                    <Button disabled={loading} onClick={() => setManualImport(previous => ({ ...previous, selected: [] }))}>清除選取</Button>
                </DialogContent>
                <DialogActions>
                    <Button disabled={loading} onClick={() => setManualImport(null)}>返回</Button>
                    <Button disabled={loading || !manualImport?.selected.length} variant="contained" onClick={() => {
                        if (selectImportCandidate(manualImport.row.rowNumber, { lines: manualImport.selected })) setManualImport(null);
                    }}>確認指定</Button>
                </DialogActions>
            </Dialog>

            {/* 新增的合計金額微調 Dialog 組件 */}
            <Dialog open={adjustDialogOpen} onClose={() => setAdjustDialogOpen(false)}>
                <DialogTitle>合計金額微調</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        請輸入調整金額。
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="new-total-amount"
                        label="調整金額"
                        type="number" // 確保類型為 number
                        fullWidth
                        variant="standard"
                        value={newTotalAmount}
                        onChange={(e) => setNewTotalAmount(e.target.value)}
                        
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAdjustDialogOpen(false)}>取消</Button>
                    <Button onClick={handleSubmitAdjustAmount}>送出</Button>
                </DialogActions>
            </Dialog>

            {/* 列印預覽 Dialog */}
            <Dialog
                fullScreen
                open={print}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', backgroundColor: 'black' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            列印預覽
                        </Typography>
                    </Toolbar>
                </AppBar>
                <PDFViewer style={{ width: '100%', height: '100%' }}>
                    <MyDocument data={rows2} billNum={billNum} billDate={billData ? (billData.date ? billData.date : '') : ''}/>
                </PDFViewer>
            </Dialog> 
        </>
    );
}

Font.register({
    family: 'TaipeiSansTCBeta-Bold',
    src: chFont, // 使用您的實際路徑
});
Font.register({
    family: 'TaipeiSansTCBeta-Light',
    src: chLight, // 使用您的實際路徑
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: 30, // 設置底部邊距，數值可根據需要調整
        // ... 其他樣式
    },
    gridContainer: {
        flexDirection: 'row',
        margin: 10,
        alignItems: 'center',
    },
    gridTitle: {
        flexGrow: 0,
        fontFamily: 'TaipeiSansTCBeta-Bold',
        alignItems: 'center',
    },
    gridItem1: {
        flexGrow: 1,
        padding: 3,
        fontFamily: 'TaipeiSansTCBeta-Bold',
    },
    gridItem2: {
        flexGrow: 1,
        padding: 3,
        fontFamily: 'TaipeiSansTCBeta-Light',
    },
    gridImg: {
        flexGrow: 1,
        paddingLeft: 100,
        paddingRight: 100,
        height:50,
        marginBottom:10
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        fontFamily: 'TaipeiSansTCBeta-Bold',
    },
    headerRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: 'black',
        alignItems: 'center',
        justifyContent: 'space-around', // 平均分配空間
        marginBottom: 10, // 與下個元素的間距
    },
    headerItem: {
        flexGrow: 1,
        textAlign: 'center',
        padding: 5, // 內間距
        fontSize: 10,
    },
    row: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: 'black',
        alignItems: 'center',
    },
    cell: {
        textAlign: 'center',
        padding: 5,
        fontSize: 10,
    },
});

const MyDocument = ({ data, billNum, billDate }) => {
    const today = new Date();
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    return (
        <> 
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        <View style={styles.gridTitle}>
                            <Text>福蒙精密工業股份有限公司-應收帳款對帳單</Text>
                        </View>
                        <View style={styles.gridContainer}>
                            <View style={styles.gridItem1}>
                                <Text>發票號碼:</Text>
                            </View>
                            <View style={styles.gridItem2}>
                                <Text>{billNum}</Text>
                            </View>
                            <View style={styles.gridItem1}>
                                <Text>列印日期:</Text>
                            </View>
                            <View style={styles.gridItem2}>
                                <Text>{formatDate(today)}</Text>
                            </View>
                        </View> 
                        <View style={styles.gridContainer}>
                            <View style={styles.gridItem1}>
                                <Text>發票日期:</Text>
                            </View>
                            <View style={styles.gridItem2}>
                                <Text>{billDate}</Text>
                            </View>
                            <View style={styles.gridItem1}>
                                <Text>頁次:</Text>
                            </View>
                            <View style={styles.gridItem2}>
                                <Text>1/1</Text>
                            </View>
                        </View>
                        <View style={styles.headerRow}>
                            <View style={styles.headerItem}>
                                <Text>出貨日期</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>出貨單號</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>訂單號碼</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>流水號</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>圖號</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>物品名</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>單位</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>實交貨數</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>訂購單價</Text>
                            </View>
                            <View style={styles.headerItem}>
                                <Text>應收金額</Text>
                            </View>
                        </View>
                        {data.map((item, index) => (
                            <View style={styles.row} key={index}>
                                <Text style={styles.cell}>{item.出貨日期}</Text>
                                <Text style={styles.cell}>{item.出貨單號}</Text>
                                <Text style={styles.cell}>{item.訂單號碼}</Text>
                                <Text style={styles.cell}>{item.流水號}</Text>
                                <Text style={styles.cell}>{item.圖號}</Text>
                                <Text style={styles.cell}>{item.物品名}</Text>
                                <Text style={styles.cell}>{item.單位}</Text>
                                <Text style={styles.cell}>{item.實交貨數}</Text>
                                <Text style={styles.cell}>{item.訂購單價}</Text>
                                <Text style={styles.cell}>{item.應收金額}</Text>
                            </View>
                        ))}
                    </View>
                </Page>
            </Document>
        </>
    );
};
